<template>
    <div v-loading="loading">
        <layout-headers :title="$t('translationsPageTitle')" :text="$t('translationsPageSubtitle')" :redirectButtons="redirectButtons"/>

        <filters :tableData="tableData" 
            v-model="search" 
            @filtered-list="getFilteredList" 
            :fields="['name', ['value', 'en'], ['value', 'mk'], ['value', 'sq']]" />
        <br>
        <div class="tabs">
            <ul>
                <li :class="{'is-active' : isActiveTab(0)}">
                    <a @click="activeTab = 0">Frontend</a>
                </li>
                <li :class="{'is-active' : isActiveTab(1)}">
                    <a @click="activeTab = 1">Cms</a>
                </li>
            </ul>
        </div>
        <br>
        <el-card>
            <el-table :data="filteredData" empty-text="Loading...">
                <el-table-column sortable prop="name" :label="$t('translationsName')"/>
                <el-table-column v-for="(value, key, index) in languages" :key="index" sortable :label="value">
                    <template slot-scope="scope">
                        {{ scope.row.value[key] }}
                    </template>
                </el-table-column>
                <el-table-column 
                    prop="actions" 
                    fixed="right"
                    width="100"
                    :label="$t('tableActions')">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" class="table-button"
                                @click="edit('TranslationEdit', scope.row, 'translation')"/>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
    </div>   
</template>

<script>
import {mapGetters} from 'vuex'
import Model from '../../model/index.js'
import LayoutHeaders from '../LayoutPart/LayoutHeaders'
import Filters from '../Filters/Filter'
import {edit} from '../../helpers/helpers'
import {getFilteredList} from '@/helpers/helpers'

export default {
    components: {
        Filters,
        LayoutHeaders
    },
    data () {
        return {
            activeTab: 0,
            filteredData: [],
            loading: true,
            resourceType: 'frontend',
            search: '',
            tableData: [],
            redirectButtons: [
                {
                    path: 'TranslationCreate',
                    param: {
                        isEdit: false,
                        translation: {
                            app_name: '',
                            name: '',
                            value: {}
                        }
                    },
                    text: 'translationCreate'
                },
            ]
        }
    },
    computed: {
        ...mapGetters({
           translations: 'getTranslations' 
        }),
        languages () {
            return Model.getLanguages()
        }
    },
    watch: {
        activeTab (data) {
            if (data === 0) {
                this.filteredData = this.translations.frontend
                this.tableData = this.translations.frontend
            } else {
                this.filteredData = this.translations.cms
                this.tableData = this.translations.cms
            }
        },
        translations (data) {
            this.filteredData = data[this.resourceType]
            this.tableData = data[this.resourceType]
            this.loading = false
        }
    },
    async created () {
        await this.$store.dispatch('fetchTranslations', '?q=frontend')
        await this.$store.dispatch('fetchTranslations', '?q=cms')

        this.filteredData = this.translations[this.resourceType]
        this.tableData = this.translations[this.resourceType]        

        this.loading = false
    },
    methods: {
        edit,
        getFilteredList,
        headerCellStyle({row, column, rowIndex, columnIndex}) {
            return {
                wordBreak: `normal`,
                textAlign: `center`,
                wordWrap: `normal`
            }
        },
        isActiveTab(id) {
            return this.activeTab === id
        },

    }
    
}
</script>

<style scoped>

.table-button {
    width: 30px !important; 
    height: 30px !important; 
    padding: 0 !important; 
    margin: 0 !important;
    background: transparent !important;
    color: darkgrey;
    font-size: 20px;
    font-weight: 800;
    border: none;
}

.table-button:hover {
    color: #409EFF !important;
}

.tabs {
        -webkit-overflow-scrolling: touch;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -webkit-box-align: stretch;
        -ms-flex-align: stretch;
        align-items: stretch;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        font-size: 1rem;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        overflow: hidden;
        overflow-x: auto;
        white-space: nowrap;
    }
    
    ul {
        padding: 0;
        margin: 0;
    }

    .tabs ul {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        border-bottom: 1px solid #dbdbdb;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
    }

    .tabs li {
        display: block;
    }

    a {
        color: #00d1b2;
        cursor: pointer;
        text-decoration: none;
        -webkit-transition: none 86ms ease-out;
        transition: none 86ms ease-out;
    }
    
    .tabs a {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        border-bottom: 1px solid #dbdbdb;
        color: #4a4a4a;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        margin-bottom: -1px;
        padding: 0.5em 1em;
        vertical-align: top;
    }

    .tabs li.is-active a {
        border-bottom-color: #409EFF;
        color: #409EFF;
    }

</style>



// WEBPACK FOOTER //
// src/components/Translations/Translations.vue